import { stack, flex, hstack, css } from '@bts-web/utils-style-engine';
import { SkeletonElement } from '../../common';

export const AssetItemSkeleton = () => (
  <div
    data-testid="asset-item-skeleton"
    className={flex({
      gap: 'medium',
      alignItems: 'center',
      padding: 'medium',
      width: '100%',
      backgroundColor: 'screen_background.primary',
      borderBottomWidth: '1px',
      borderBottomColor: 'neutrals.divider',
    })}
  >
    <SkeletonElement width="40px" height="40px" borderRadius="50%" />

    <div
      className={hstack({
        justifyContent: 'space-between',
        flex: 1,
        gap: 'small',
      })}
    >
      <div className={stack({ gap: 'extra_small_3', flex: 1 })}>
        <SkeletonElement width="80px" height="22px" />
        <SkeletonElement height="18px" />
      </div>

      <div className={stack({ gap: 'extra_small_3' })}>
        <SkeletonElement width="54px" height="16px" borderRadius="30px" />
        <SkeletonElement width="56px" height="20px" borderRadius="30px" />
      </div>
    </div>
  </div>
);

export const AssetsHeaderLoadingSkeleton = () => {
  const skeletonVariants = (
    <>
      <SkeletonElement width="100%" height="50px" borderRadius="12px" />
      <div className={flex({ gap: 'extra_small_2' })}>
        <SkeletonElement width="90px" height="38px" borderRadius="50px" />
        <SkeletonElement width="76px" height="38px" borderRadius="50px" />
        <SkeletonElement width="56px" height="38px" borderRadius="50px" />
        <SkeletonElement width="76px" height="38px" borderRadius="50px" />
      </div>
      <div className={flex({ gap: 'extra_small_2' })}>
        <SkeletonElement width="96px" height="40px" borderRadius="50px" />
        <SkeletonElement width="40px" height="40px" borderRadius="50%" />
      </div>
    </>
  );

  return (
    <div
      data-testid="assets-loading-skeleton"
      className={stack({
        backgroundColor: 'screen_background.primary',
        borderBottomWidth: '1px',
        borderBottomColor: 'neutrals.divider',
        gap: { base: 'extra_small_2', lg: 'small' },
        py: { base: 'extra_small_2', lg: 'small' },
        px: { base: 'small', lg: 'medium' },
      })}
    >
      {skeletonVariants}
    </div>
  );
};

export const AssetsListSkeleton = () => (
  <>
    <AssetItemSkeleton />
    <AssetItemSkeleton />
    <AssetItemSkeleton />
    <AssetItemSkeleton />
    <AssetItemSkeleton />
    <AssetItemSkeleton />
    <AssetItemSkeleton />
  </>
);

export const AssetsDiscoverPageSkeleton = () => (
  <div className={css({ height: '100vh', bg: 'screen_background.primary' })}>
    <AssetsHeaderLoadingSkeleton />
    <AssetsListSkeleton />
  </div>
);
